import { render, staticRenderFns } from "./PatientTable.vue?vue&type=template&id=adc2ca8e"
import script from "./PatientTable.vue?vue&type=script&lang=ts"
export * from "./PatientTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports